var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_vm._l((_vm.headerArray),function(item,key){return _c('div',{key:key,staticClass:"quote-header"},[_vm._v(" "+_vm._s(item.label)+" ")])}),(_vm.showBuySellColumn)?_c('div',{staticClass:"quote-header hide-on-mobile"},[_vm._v("   ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }